import { render, staticRenderFns } from "./AdsHistoryTable.vue?vue&type=template&id=4736e3fc"
import script from "./AdsHistoryTable.vue?vue&type=script&lang=js"
export * from "./AdsHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports